import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form } from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function ReportSettingForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  return (
    <>
      <Form>
        <Panel bordered header={schema.approveSubProject.header} collapsible defaultExpanded>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.approveSubProject.approverName.validators,
                  schema.approveSubProject.approverName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.approveSubProject.approverName]} />
              <Input
                placeholder={schema.approveSubProject.approverName.placeholder}
                defaultValue={schema.approveSubProject.approverName.value}
                name={schema.approveSubProject.approverName.name}
                inputRef={register(isValidators(schema.approveSubProject.approverName.validators))}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.approveSubProject.approveSubProjectPosition.validators,
                  schema.approveSubProject.approveSubProjectPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.approveSubProject.approveSubProjectPosition]} />
              <Input
                placeholder={schema.approveSubProject.approveSubProjectPosition.placeholder}
                defaultValue={schema.approveSubProject.approveSubProjectPosition.value}
                name={schema.approveSubProject.approveSubProjectPosition.name}
                inputRef={register(
                  isValidators(schema.approveSubProject.approveSubProjectPosition.validators)
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.approveSubProject.approveCoordinator.validators,
                  schema.approveSubProject.approveCoordinator.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.approveSubProject.approveCoordinator]} />
              <Input
                placeholder={schema.approveSubProject.approveCoordinator.placeholder}
                defaultValue={schema.approveSubProject.approveCoordinator.value}
                name={schema.approveSubProject.approveCoordinator.name}
                inputRef={register(
                  isValidators(schema.approveSubProject.approveCoordinator.validators)
                )}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.approveSubProject.approveCoordinatorPosition.validators,
                  schema.approveSubProject.approveCoordinatorPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.approveSubProject.approveCoordinatorPosition]} />
              <Input
                placeholder={schema.approveSubProject.approveCoordinatorPosition.placeholder}
                defaultValue={schema.approveSubProject.approveCoordinatorPosition.value}
                name={schema.approveSubProject.approveCoordinatorPosition.name}
                inputRef={register(
                  isValidators(schema.approveSubProject.approveCoordinatorPosition.validators)
                )}
              />
            </Col>
          </Row>
        </Panel>
        <br />
        <Panel bordered header={schema.printContract.header} collapsible defaultExpanded>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.projectManagerName.validators,
                  schema.printContract.projectManagerName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.projectManagerName]} />
              <Input
                placeholder={schema.printContract.projectManagerName.placeholder}
                defaultValue={schema.printContract.projectManagerName.value}
                name={schema.printContract.projectManagerName.name}
                inputRef={register(
                  isValidators(schema.printContract.projectManagerName.validators)
                )}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.projectManagerPosition.validators,
                  schema.printContract.projectManagerPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.projectManagerPosition]} />
              <Input
                placeholder={schema.printContract.projectManagerPosition.placeholder}
                defaultValue={schema.printContract.projectManagerPosition.value}
                name={schema.printContract.projectManagerPosition.name}
                inputRef={register(
                  isValidators(schema.printContract.projectManagerPosition.validators)
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.projectLeaderName.validators,
                  schema.printContract.projectLeaderName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.projectLeaderName]} />
              <Input
                placeholder={schema.printContract.projectLeaderName.placeholder}
                defaultValue={schema.printContract.projectLeaderName.value}
                name={schema.printContract.projectLeaderName.name}
                inputRef={register(isValidators(schema.printContract.projectLeaderName.validators))}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.projectLeaderPosition.validators,
                  schema.printContract.projectLeaderPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.projectLeaderPosition]} />
              <Input
                placeholder={schema.printContract.projectLeaderPosition.placeholder}
                defaultValue={schema.printContract.projectLeaderPosition.value}
                name={schema.printContract.projectLeaderPosition.name}
                inputRef={register(
                  isValidators(schema.printContract.projectLeaderPosition.validators)
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.firstWitnessName.validators,
                  schema.printContract.firstWitnessName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.firstWitnessName]} />
              <Input
                placeholder={schema.printContract.firstWitnessName.placeholder}
                defaultValue={schema.printContract.firstWitnessName.value}
                name={schema.printContract.firstWitnessName.name}
                inputRef={register(isValidators(schema.printContract.firstWitnessName.validators))}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.firstWitnessPosition.validators,
                  schema.printContract.firstWitnessPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.firstWitnessPosition]} />
              <Input
                placeholder={schema.printContract.firstWitnessPosition.placeholder}
                defaultValue={schema.printContract.firstWitnessPosition.value}
                name={schema.printContract.firstWitnessPosition.name}
                inputRef={register(
                  isValidators(schema.printContract.firstWitnessPosition.validators)
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.secondWitnessName.validators,
                  schema.printContract.secondWitnessName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.secondWitnessName]} />
              <Input
                placeholder={schema.printContract.secondWitnessName.placeholder}
                defaultValue={schema.printContract.secondWitnessName.value}
                name={schema.printContract.secondWitnessName.name}
                inputRef={register(isValidators(schema.printContract.secondWitnessName.validators))}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.printContract.secondWitnessPosition.validators,
                  schema.printContract.secondWitnessPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.printContract.secondWitnessPosition]} />
              <Input
                placeholder={schema.printContract.secondWitnessPosition.placeholder}
                defaultValue={schema.printContract.secondWitnessPosition.value}
                name={schema.printContract.secondWitnessPosition.name}
                inputRef={register(
                  isValidators(schema.printContract.secondWitnessPosition.validators)
                )}
              />
            </Col>
          </Row>
        </Panel>
        <br />
        <Panel
          bordered
          header={schema.projectWithdrawalRequestForm.header}
          collapsible
          defaultExpanded
        >
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.projectWithdrawalRequestForm.projectManagerApproveName.validators,
                  schema.projectWithdrawalRequestForm.projectManagerApproveName.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={errors[schema.projectWithdrawalRequestForm.projectManagerApproveName]}
              />
              <Input
                placeholder={
                  schema.projectWithdrawalRequestForm.projectManagerApproveName.placeholder
                }
                defaultValue={schema.projectWithdrawalRequestForm.projectManagerApproveName.value}
                name={schema.projectWithdrawalRequestForm.projectManagerApproveName.name}
                inputRef={register(
                  isValidators(
                    schema.projectWithdrawalRequestForm.projectManagerApproveName.validators
                  )
                )}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.projectWithdrawalRequestForm.projectManagerApprovePosition.validators,
                  schema.projectWithdrawalRequestForm.projectManagerApprovePosition.label
                )}
              </ControlLabel>
              <ErrorMessage
                error={errors[schema.projectWithdrawalRequestForm.projectManagerApprovePosition]}
              />
              <Input
                placeholder={
                  schema.projectWithdrawalRequestForm.projectManagerApprovePosition.placeholder
                }
                defaultValue={
                  schema.projectWithdrawalRequestForm.projectManagerApprovePosition.value
                }
                name={schema.projectWithdrawalRequestForm.projectManagerApprovePosition.name}
                inputRef={register(
                  isValidators(
                    schema.projectWithdrawalRequestForm.projectManagerApprovePosition.validators
                  )
                )}
              />
            </Col>
          </Row>
        </Panel>
        <br />
        <Panel bordered header={schema.reportSummary.header} collapsible defaultExpanded>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.reportSummary.reportSummaryName.validators,
                  schema.reportSummary.reportSummaryName.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.reportSummary.reportSummaryName]} />
              <Input
                placeholder={schema.reportSummary.reportSummaryName.placeholder}
                defaultValue={schema.reportSummary.reportSummaryName.value}
                name={schema.reportSummary.reportSummaryName.name}
                inputRef={register(isValidators(schema.reportSummary.reportSummaryName.validators))}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} style={{ marginTop: '10px' }}>
              <ControlLabel>
                {requiredFiled(
                  schema.reportSummary.reportSummaryPosition.validators,
                  schema.reportSummary.reportSummaryPosition.label
                )}
              </ControlLabel>
              <ErrorMessage error={errors[schema.reportSummary.reportSummaryPosition]} />
              <Input
                placeholder={schema.reportSummary.reportSummaryPosition.placeholder}
                defaultValue={schema.reportSummary.reportSummaryPosition.value}
                name={schema.reportSummary.reportSummaryPosition.name}
                inputRef={register(
                  isValidators(schema.reportSummary.reportSummaryPosition.validators)
                )}
              />
            </Col>
          </Row>
        </Panel>
      </Form>
    </>
  )
}
